<div class="dropdown-container" [class.has-error]="touched && required && !value && selectedValues.length === 0">
  <label class="form-label">{{ label }}</label>
  <mat-form-field appearance="outline" class="dropdown-field custom-select">
    <mat-select
      class="dropdown-control"
      [formControl]="formControl"
      [placeholder]="loading ? 'Loading...' : placeholder"
      [disabled]="disabled || loading"
      [required]="required"
      [multiple]="multiple"
      (selectionChange)="onSelectionChange($event)"
      (blur)="onBlur()"
      [id]="id || name"
    >
      <mat-option *ngIf="loading" disabled>
        <div style="text-align: center; padding: 10px; display: flex; align-items: center; justify-content: center">
          <mat-spinner diameter="20" style="margin-right: 8px"></mat-spinner>
          Loading...
        </div>
      </mat-option>
      <mat-option *ngFor="let option of options" [value]="option.id" [disabled]="option.disabled">
        {{ option.text }}
      </mat-option>
    </mat-select>
    <button
      mat-icon-button
      matSuffix
      type="button"
      aria-label="Clear selection"
      (click)="clearSelection()"
      *ngIf="!loading && !disabled && ((multiple && selectedValues.length > 0) || (!multiple && value))"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
